import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import {
  AboutDiv,
  Column,
  Img,
  AboutInfo,
  AboutInfoP,
  HeaderUl,
  HeaderLi,
  JelloHori,
} from "./Styles";

import { Container, H1 } from "../../SharedStyles/SharedStyles";
const socialMediaLinks = [
  {
    id: 0,
    link: "https://www.linkedin.com/in/ruby-roy-b2a7a6213/",
    icon: <FaLinkedin />,
  },
  {
    id: 1,
    link: "https://github.com/rubyroy21",
    icon: <FaGithub />,
  },
  // {
  //     id: 2,
  //     link: 'https://twitter.com/aadityaneve',
  //     icon: <FaTwitter />,
  // },
  /* {
        id: 3,
        link: 'https://leetcode.com/aadityaneve',
        icon: <SiLeetcode />,
    }, */
];
const About = () => {
  return (
    <Container className="about">
      <AboutDiv>
        <Column>
          <Img
            src="https://avatars.githubusercontent.com/u/93375457?s=400&u=6b2e4e26a925b2ad69c7e627d880824df9595941&v=4"
            alt="my image"
          />
        </Column>
        <Column>
          <H1>About Me</H1>
          <AboutInfo>
            <AboutInfoP>
              Contrivance designer and aspiring Full Stack Web Developer with an
              expertise in MERN Stack. Self-disciplined and blazing with
              curiosity, with a keen interest in innovation of the Tech World.
              Eagerly anticipating to show my skills in an inspiring work
              domain.
            </AboutInfoP>
            <AboutInfoP>You can take a look at my work here -</AboutInfoP>
          </AboutInfo>
          <HeaderUl>
            {socialMediaLinks.map((item) => (
              <JelloHori key={item.id}>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <HeaderLi>{item.icon}</HeaderLi>
                </a>
              </JelloHori>
            ))}
          </HeaderUl>
        </Column>
      </AboutDiv>
    </Container>
  );
};

export default About;
